import { IonPage, IonText, IonContent, IonIcon, IonButton } from '@ionic/react';
import { alertCircle } from 'ionicons/icons';
import React from 'react';
import styled from 'styled-components';
import { t } from 'ttag';

import { Browser } from '~capacitor-plugins/browser';

declare const ENV: string;

const SUPPORT_EMAIL = 'support@eventmobi.com';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
`;

const TextBlock = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
`;

const AlertIcon = styled(IonIcon)`
  margin-right: 5px;
  font-size: 24px;
`;

const Body = styled.div`
  overflow: auto;
  width: 100%;
  padding: 0 10px;
`;

const Footer = styled.div`
  margin-top: 10px;
`;

const StackTrace = styled.pre`
  margin: 0;
`;

const Header = () => (
  <TextBlock>
    <AlertIcon color="danger" icon={alertCircle} />
    <IonText color="danger">{t`Oops! Something went wrong`}</IonText>
  </TextBlock>
);

const GenericError = () => (
  <IonPage>
    <IonContent fullscreen>
      <Content>
        <Header />
        <IonText>{t`For further assistance please`}</IonText>
        <Footer>
          <IonButton
            role="button"
            fill="clear"
            size="small"
            className="ion-text-capitalize"
            onClick={() => Browser.open({ url: `mailto:${SUPPORT_EMAIL}` })}
          >
            {t`Contact Support`}
          </IonButton>
        </Footer>
      </Content>
    </IonContent>
  </IonPage>
);

type Props = {
  error: Error;
  componentStack: string | null;
  resetError: () => void;
};

const Fallback = ({ error, componentStack, resetError }: Props) => {
  if (ENV !== 'development') {
    return <GenericError />;
  }

  return (
    <IonPage>
      <IonContent fullscreen>
        <Content>
          <Header />
          <Body>
            <IonText>{error.toString()}</IonText>
            <StackTrace>{componentStack}</StackTrace>
          </Body>
          <Footer>
            <IonButton
              role="button"
              fill="clear"
              size="small"
              className="ion-text-capitalize"
              onClick={resetError}
            >
              Try Again
            </IonButton>
          </Footer>
        </Content>
      </IonContent>
    </IonPage>
  );
};

export default Fallback;
